import forEach from 'lodash/forEach'
import forOwn from 'lodash/forOwn'
import orderBy from 'lodash/orderBy'

export const prepareTagForFrontend = (backend_tag) => {
  const frontend_tag = Object.assign({}, backend_tag)
  frontend_tag.id = frontend_tag.slug //For GET requests to Django

  // value and label are used for react-select
  // If they're already set, use existing values.
  // Otherwise, convert from name and slug
  frontend_tag.value = frontend_tag.value || frontend_tag.slug
  frontend_tag.label = frontend_tag.label || frontend_tag.name
  delete frontend_tag.name
  return frontend_tag
}

export const getListofTagNames = (frontend_tags) => {
  //Works where `frontend_tags` is an object or array
  const tag_names = []
  forEach(frontend_tags, (tag) => {
    tag_names.push(tag.label)
  })
  return tag_names
}

export const convertTagTreeToList = (tagTree) => {
  //TagTree includes items and rootId
  //Each item is a tag, including data (name, slug, etc.) and children
  //The rootId is the slug of the tag at the root of the tree
  const tagsArray = []
  forOwn(tagTree.items, (value, key) => {
    //key is slug and value is object containing tag data and children
    if (key !== tagTree.rootId) {
      //exclude root tag
      tagsArray.push({ value: key, label: value.data.name })
    }
  })
  //Order alphabetically
  return orderBy(tagsArray, [(tag) => tag.label.toLowerCase()])
}
